import React, { ReactNode, useMemo } from 'react';
import { AudioServicesProvider, type AudioServicesValue } from '@doer/frontend-components/creativity-editor';
import { useGenerateAudioTts } from '../../../hooks/audio/use-generate-audio-tts';
import { useListMusicTracks } from '../../../hooks/audio/use-list-music-tracks';

/**
 * Wrapper centralizado: arma el `AudioServicesValue` usando los hooks de Brands
 * (que a su vez usan `callEndpoint` del `useAPIContext`) y lo inyecta al editor
 * vía <AudioServicesProvider>.
 *
 * Las páginas que monten <CreativityEditor> envuelven con este componente en
 * vez de duplicar el wiring. Si las firmas de los hooks cambian, se actualiza
 * acá y todas las páginas lo heredan.
 */
export const BrandsAudioServicesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { generateAudioTts } = useGenerateAudioTts();
  const { listMusicTracks } = useListMusicTracks();

  const value = useMemo<AudioServicesValue>(
    () => ({
      generateVoiceover: generateAudioTts,
      loadMusicTracks: async () => {
        const res = await listMusicTracks();
        return res?.tracks ?? null;
      }
    }),
    [generateAudioTts, listMusicTracks]
  );

  return <AudioServicesProvider value={value}>{children}</AudioServicesProvider>;
};
